import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete, MdFilterList } from "react-icons/md";
import PageLayout from "../../Layouts/PageLayout/PageLayout";
import Table from "../../components/common/Table/Table";
import Button from "../../components/common/Button/Button";
import InputSearch from "../../components/common/Inputs/InputSearch/InputSearch";
import { FiDownload } from "react-icons/fi";
import { GrAdd } from "react-icons/gr";
import { LuArrowDownUp } from "react-icons/lu";
import "./Residuos.scss";
import { getApiInstance } from "../../utils/api";
import { useZone } from "../../context/ZoneContext";
import { mapList } from "../../utils/utils";

const columnasResiduos = [
    { key: "id", label: "ID", visible: false },
    {
        key: "codigo",
        label: "Código Obra",
        visible: true,
        sortable: true,
        isLink: true,
        width: "120px",
    },
    { key: "nombre", label: "Nombre", visible: true, sortable: true },
    {
        key: "tipoResiduo",
        label: "Tipo de residuo",
        visible: true,
        sortable: true,
        width: "200px",
        render: (row) => row.tipoResiduo?.descripcion ?? "",
    },
];

const filterFields = [
    { key: "nombre", label: "Nombre", type: "multiselect" },
    { key: "tipoResiduo", label: "Tipo de residuo", type: "multiselect", objectProp: "descripcion" },
];

export default function Residuos() {
    const [residuos, setResiduos] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();
    const [residuosTipo, setResiduosTipo] = useState([]);

  const fetchResiduos = async () => {
    setLoading(true);
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/Residuos/GetResiduosByZona?codZona=${selectedZone.value}`
      );

      setResiduos(response.data);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las obras. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

    const fetchResiduosTipo = async () => {
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/ResiduosTipo/GetResiduosTipoByZona/${selectedZone.value}`
      );

      setResiduosTipo([...mapList(response.data, "descripcion", "codTipoResiduo")]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las obras. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    fetchResiduos();
    fetchResiduosTipo();
  }, [selectedZone]);

    return (
        <PageLayout
            title="Residuos"
            subtitle="Aquí verás todos los residuos de tu organización"
            actions={[
                <Button
                    key="export"
                    componentType="link"
                    variant="outlined"
                    href="/"
                    startIcon={<FiDownload />}
                >
                    Exportar Excel
                </Button>
            ]}
        >
            <div className="residuos-table">
                <Table
                    columns={columnasResiduos}
                    dataTable={residuos}
                    showCheckboxes={false}
                    rowsPerPage={10}
                    noResultsMessage="No se han encontrado residuos."
                    actions={["Eliminar", "Editar"]}
                    searchTerms={["codigoObra", "nombre", "tipoResiduo"]}
                    keyProp="codResiduo"
                    elementName="Residuo"
                    sortProp="nombre"
                    formElements={[
                        {
                            elements: [
                                {
                                    name: "codigo",
                                    type: "text",
                                    label: "Código Ler",
                                    placeholder: "Ingrese el código ler",
                                    required: true,
                                    disabled: false,
                                    labelVisible: true,
                                    visible: true,
                                },
                                {
                                    name: "nombre",
                                    type: "text",
                                    label: "Nombre",
                                    placeholder:
                                        "Ingrese el nombre del residuo",
                                    required: true,
                                    disabled: false,
                                    labelVisible: true,
                                    visible: true,
                                },
                                {
                                    name: "codTipoResiduo",
                                    type: "select",
                                    label: "Tipo de residuo",
                                    placeholder:
                                        "Seleccione el tipo de residuo",
                                    required: true,
                                    disabled: false,
                                    labelVisible: true,
                                    visible: true,
                                    options: residuosTipo,
                                },
                                {
                                    name: "descripcion",
                                    type: "textarea",
                                    label: "Descripción",
                                    placeholder:
                                        "Ingrese una descripción detallada del residuo",
                                    required: false,
                                    disabled: false,
                                    labelVisible: true,
                                    visible: true,
                                },
                                {
                                    name: "codZona",
                                    type: "hidden",
                                    label: "Zona",
                                    placeholder: "",
                                    required: true,
                                    disabled: false,
                                    labelVisible: false,
                                    visible: false,
                                    defaultValue: selectedZone.value,
                                }
                            ],
                        },
                    ]}
                    loading={loading}
                    filterFields={filterFields}
                    addApiUrl="/api/Residuos/SetResiduo"
                    editApiUrl="/api/Residuos/EditResiduo"
                    deleteApiUrl="/api/Residuos/DeleteResiduo"
                />
            </div>
        </PageLayout>
    );
}
